import { List } from '../../domain/list/ListDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ListActions } from '../actions/ListActions';
import ValueFactory from '../../util/ValueFactory';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';

export interface ListState {
  list: List;
  isUpdate: boolean;
  data: Array<Record<string, any>>;
  newData: Record<string, any> | null;
  dependencies: ComponentDependency[];
  isDirty: boolean;
}

const initialState: ListState = {
  list: ValueFactory.initializeList(),
  isUpdate: false,
  data: [],
  newData: null,
  dependencies: [],
  isDirty: false,
};

export const listReducer = (state = initialState, action: ReduxBaseAction<any, ListActions>) => {
  switch (action.type) {
    case 'CHANGE_LIST':
      return { ...state, list: action.payload };
    case 'CHANGE_LIST_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CHANGE_LIST_DATA':
      return { ...state, data: action.payload };
    case 'CLEAR_LIST':
      return {
        ...state,
        list: ValueFactory.initializeList(),
        isUpdate: false,
        data: [],
        dependencies: [],
        isDirty: false,
      };
    case 'CHANGE_LIST_CREATED_DATA':
      return { ...state, newData: action.payload };
    case 'CHANGE_LIST_DEPENDENCIES':
      return { ...state, dependencies: action.payload };
    case 'CHANGE_LIST_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
